import { Observable, BehaviorSubject, of as observableOf } from 'rxjs';
import { mergeMap, catchError, share } from "rxjs/operators";
import { AnouncementDelegate } from "./anouncement.delegate";
import { IAnouncement, INewAnouncement, IUpdateAnouncementResponse } from "./anouncement.interface";
import { AuthenticationService } from "../AuthenticationService";

export class AnouncementService
{
    private anouncementData: IAnouncement[] = null;
    private anouncementSubject: BehaviorSubject<IAnouncement[]> = new BehaviorSubject(null);
    public anouncements: Observable<IAnouncement[]> = this.anouncementSubject;

    private anouncementFilterSubject: BehaviorSubject<IAnouncement[]> = new BehaviorSubject(null);
    public anouncementsFiltered: Observable<IAnouncement[]> = this.anouncementFilterSubject;

    constructor(private anouncementDelegate: AnouncementDelegate, private authenticationService: AuthenticationService)
    {
    }

    public getAllAnouncements(): void
    {
        if (this.anouncementData !== null && this.anouncementData.length > 0)
        {
            return;
        }
        const orgId = this.authenticationService.GetOrgId();
        const response = this.anouncementDelegate.getAllAnouncements(orgId);
        this.processAnouncements(response);
    }

    public getAnouncementByAnouncementId(anouncementId: string): IAnouncement
    {
        return this.anouncementData.find(anoucement => anoucement.anouncementId === anouncementId);
    }

    public createAnouncement(newAnouncement: INewAnouncement): Observable<string>
    {
        newAnouncement.clientTimeStamp = new Date().toISOString();
        newAnouncement.orgId = this.authenticationService.GetOrgId();
        var result = this.anouncementDelegate.createNewAnouncement(newAnouncement);
        return result.pipe(mergeMap((response: IUpdateAnouncementResponse) =>
        {
            if (!response)
            {
                return observableOf(null);
            }
            this.anouncementData = response.anouncements;
            this.anouncementSubject.next(this.anouncementData);
            this.anouncementFilterSubject.next(this.anouncementData);
            return observableOf(response.id);

        }),
            catchError((error: any) => observableOf(null)),
            share());
    }

    public updateAnouncement(anouncement: IAnouncement, anouncementId: string): Observable<boolean>
    {
        anouncement.anouncementId = anouncementId;
        anouncement.clientTimeStamp = new Date().toISOString();
        anouncement.orgId = this.authenticationService.GetOrgId();
        const response = this.anouncementDelegate.updateAnouncement(anouncement);
        return this.processAnouncements(response);
    }

    private processAnouncements(anouncements: Observable<IAnouncement[]>): Observable<boolean>
    {
        anouncements.subscribe(onSuccess.bind(this), onFault.bind(this));

        return anouncements.pipe(mergeMap((response: any) => !response ? observableOf(false) : observableOf(true)),
            catchError(() => observableOf(false)),
            share());

        function onSuccess(anouncements: IAnouncement[])
        {
            this.anouncementData = anouncements;
            this.anouncementSubject.next(this.anouncementData);
            this.anouncementFilterSubject.next(this.anouncementData);
        }

        function onFault(error: any)
        {
            //AnouncementService.logger.error(`processAnouncements Fault - Error (${JSON.stringify(error)})`);
        }
    }
}